<template>
    <div id="app">
        <v-app app>
            <NavigationBar v-if="showNavBarAndFooter"></NavigationBar>
            <v-main class="main-style">
                <!--            여기 router-view 는 navBar 밑에 children routes들에 감. -->
                <!--            Home.vue를 따로 만들어야 함. -->
                <v-fade-transition mode="out-in" :appear="true" :duration="200">
                    <router-view></router-view>
                </v-fade-transition>
            </v-main>
            <Footer v-if="showNavBarAndFooter"></Footer>

            <!--            <ChannelIO style="height: 250px !important;" v-if="this.showChannelIOandKakaoButton">adfsaf</ChannelIO>-->
            <!--            <KakaoChannelButton v-if="this.showFloatingButton"></KakaoChannelButton>-->
            <ContactButton v-if="showContactButton"></ContactButton>
            <KakaoFloatingButton v-if="this.showContactButton"></KakaoFloatingButton>
            <FloatingPayButton v-if="this.showFloatingButton"></FloatingPayButton>
            <FloatingBootcampButton v-if="this.showFloatingBootcampButton"></FloatingBootcampButton>
        </v-app>
    </div>
</template>
<script>
    import NavigationBar from "../components/NavigationBar";
    import FloatingPayButton from "../components/helpers/FloatingPayButton";
    import Footer from "../components/helpers/Footer";
    // import ChannelIO from "../components/helpers/ChannelIO";
    import KakaoFloatingButton from "../components/helpers/KakaoFloatingButton";
    import ContactButton from "../components/helpers/ContactButton";
    import FloatingBootcampButton from "../components/bootcamp/FloatingBootcampButton";
    // import KakaoChannelButton from "../components/helpers/KakaoChannelButton";

    export default {
        computed: {
            currentUser() {

                return this.$store.state.auth.user;
            },
            getDefaultLanguage() {
                return window.navigator.userLanguage || window.navigator.language;
            },
            showFooter() {
                if (this.$route.name == 'profile') {
                    return false;
                }
                return true;
            },
            showFloatingBootcampButton() {
                // console.log(this.currentUser == true);
                if (this.currentUser) {
                    if (this.currentUser.roles[0] == 'ROLE_TEACHER' || this.currentUser.roles[0] == 'ROLE_ADMIN') {
                        return false
                    }
                }
                if (this.$route.name == 'BootcampMain' || this.$route.name == 'FinalBootcamp' || this.$route.name == 'ApCalculusAshley'
                || this.$route.name == 'APChemistryShin' ||this.$route.name == 'APCalculusHenry') {

                    return true;
                }
                return false;
            },

            showFloatingButton() {
                // console.log(this.currentUser == true);
                if (this.currentUser) {
                    if (this.currentUser.roles[0] == 'ROLE_TEACHER' || this.currentUser.roles[0] == 'ROLE_ADMIN') {
                        return false
                    }
                }
                if (this.$route.name == 'home' || this.$route.name == 'HomeTest-new') {

                    return true;
                }
                return false;
            },
            showContactButton() {
                if (this.$route.name == 'home'
                    || this.$route.name == 'scheduleCall'
                    || this.$route.name =='HomeTest-new'
                    || this.$route.name == 'BootcampMain'
                ) {
                    return true;
                }
                return false;
            },
            showChannelIOandKakaoButton() {
                if (this.$route.name == 'home'
                    || this.$route.name == 'profile'
                    || this.$route.name == 'viewTeacherSummary'
                    || this.$route.name == 'scheduleCall'
                ) {

                    return true;
                }
                return false;
            },
            showNavBarAndFooter() {
                if (this.$route.name == 'scheduleCall' || this.$route.name == 'BootcampSummer2026') {
                    return false;
                }
                return true;
            },

        },
        mounted() {
        },
        components: {
            FloatingBootcampButton,
            ContactButton,
            // KakaoChannelButton,
            KakaoFloatingButton,
            // ChannelIO,
            Footer,
            NavigationBar,
            FloatingPayButton
        },
        methods: {
            // showFloatingButton() {
            //
            // }
        }

    }
</script>
<style scoped>
    .main-style {
        /*background: url(../assets/library_002.jpeg) center center/cover no-repeat;*/
        /*background-color: #b71c1c;*/
    }


    .top-banner a, .top-banner span {
        display: inline-block;
    }

    .top-banner a {
        width: 100%;
        /*padding: 15px 0;*/
        text-decoration: none;
        color: #2200cc;
        /*color: rgba(255, 255, 255, .8);*/
    }

    .top-banner span {
        /*width: 50px;*/
        /*heigth: 28px;*/
        text-align: justify-all;
        /*line-height: 28px;*/
        background-color: #ffcccb;
        border-radius: 20px;
    }

    .top-banner a:hover {
        color: #fff9e0;
    }

</style>
